'use client';

import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useProduct } from 'frontastic';
import SearchModalControlled from './SearchModalControlled';

type Props = {
  onClose: () => void;
};

const SearchModal: React.FC<Props> = ({ onClose }) => {
  const [query, setQuery] = useState('');

  const [debouncedQuery] = useDebounce(query, 150);

  const { products } = useProduct({ query: debouncedQuery, limit: 6 });

  return <SearchModalControlled items={products} onQueryUpdate={setQuery} onClose={onClose} />;
};

export default SearchModal;
